module.exports = __webpack_public_path__ + "static/media/Gallery-1.64591a0e.jpg";